module.exports = __webpack_public_path__ + "img/img15.855be1b1.png";